<template>
  <v-card-title>
    <v-container class="pa-12">
      <v-card class="pl-16 pr-16 pt-8 pb-16">
        <!-- <div fill-width class="pb-5" align="end">
          <v-btn
            class="mx-2"
            fab
            dark
            color="#689ADE"
            @click="saveAdvanceDraft()"
          >
            <v-icon color="black">
              mdi-close
            </v-icon>
          </v-btn>
        </div> -->
        <v-card-title>
          <v-row>
            <v-col cols="6" md="6" justify="center">
              <h3>Add Petty Cash</h3>
            </v-col>
            <v-col cols="6" md="6">
              <v-row>
                <v-col class="text-right" cols="12" md="12">
                  <h5>No. 0000</h5>
                  <h5>Date. {{ dateCurrent }}</h5>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-title>

        <v-simple-table>
          <!-- table top section -->
          <template v-slot:top>
            <v-row class="row1  heightsize70formadvance">
              <v-col cols="12" md="4">
                <v-text-field v-model="setusername" outlined disabled dense label="Reqester"
                  background-color="#F5F5F5"></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete v-model="emp_draw" :items="emp_list" item-text="name" item-value="id" label="Payee"
                  outlined dense></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="department" outlined disabled dense label="Department"
                  background-color="#F5F5F5"></v-text-field>
              </v-col>
            </v-row>

            <v-row class="row1 heightsize70formadvance">


              <v-col cols="12" md="4">
                <v-autocomplete v-model="emp_draw_jobtitle" :items="jobtitle_list" item-text="name" item-value="id"
                  label="Job" outlined dense clearable @click:clear="
                    $nextTick(() => {
                      emp_draw_jobtitle = 0;
                    })
                    "></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4">
                <v-autocomplete v-model="customer_id" :items="customer_list" item-text="name" item-value="id" outlined
                  dense label="Client" clearable @click:clear="
                    $nextTick(() => {
                      customer_id = 0;
                    })
                    "></v-autocomplete>
              </v-col>
            </v-row>

            <br />
          </template>
        </v-simple-table>
        <template>
          <template>
            <v-data-table :headers="headers" :items="desserts" sort-by="calories" class="elevation-1"
              hide-default-footer hide-default-header>
              <template v-slot:header="{ props: { headers } }">
                <thead>
                  <tr>
                    <th v-for="h in headers" :class="h.class">
                      <span>{{ h.text }}</span>
                    </th>
                  </tr>
                </thead>
              </template>

              <template v-slot:top>
                <v-toolbar flat>


                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5">Are you sure you want to delete this
                        item?</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-toolbar>
              </template>
              <template v-slot:item.actions="{ item }">
                <!-- <v-icon small class="mr-2" @click="editItem(item)">
                  mdi-pencil
                </v-icon> -->

                <v-btn @click="deleteItem(item)" :style="{
                  backgroundColor: '#9E3B1B',
                  color: 'white',
                }">
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                  Reset
                </v-btn>
              </template>
            </v-data-table>
          </template>
          <div class="pl-2 pr-2 pt-2 elevation-1 heightsize55formadvance">
            <template>
              <v-row>
                <v-col cols="12" sm="9" md="9">
                  <v-text-field v-model="editedItem.description" ref="txtDescription" dense outlined label="Description"
                    @keydown.enter="changeFocusText(3)"></v-text-field>
                </v-col>
                <v-col cols="12" sm="2" md="2">
                  <v-text-field v-model="editedItem.amount" ref="txtAmount" label="Amount" type="number" dense outlined
                    @keydown.enter="save()"></v-text-field>
                </v-col>
                <v-col cols="12" sm="1" md="1"></v-col>
              </v-row>
            </template>
          </div>
        </template>

        <br />
        <v-row class="heightsize55formadvance pl-2 pr-2 pt-2">
          <v-col class="text-right" cols="12" sm="9" md="9">Total</v-col>
          <v-col class="text-right" cols="12" sm="2" md="2">

            <v-row>
              <v-col cols="12" md="12">
                <v-row>
                  <v-col class="text-right" cols="12" md="12">
                    <!--:suffix="sumwithdrawamount" -->
                    <v-text-field reverse filled disabled outlined dense v-model="sumwithdrawamount"></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="text-right" cols="12" sm="1" md="1"></v-col>
        </v-row>

        <v-row align="start" justify="start">
          <v-col cols="12" md="6">
            <v-radio-group v-model="radioGroup" @change="changeradio()">
              <v-radio key="bank" label="Transfer" value="bank"></v-radio>
              <v-col v-show="pickbank">
                <v-autocomplete v-model="selectbankname" :items="bankname" label="Select Bank" outlined
                  dense></v-autocomplete>
                <v-text-field outlined dense v-model="bankNumber" label="Account Number"></v-text-field></v-col>

              <v-radio key="cash" label="Cash" value="cash"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row align="start" class="pb-10 pl-3">
          <v-col cols="12" md="4">
            <v-row class="pt-4">
              <span style="font-size: 18px;"> Attached File</span>
            </v-row>
            <v-row class="mt-0">
              <span style="font-size: 14px; " class="red--text">(Support .pdf .png .jpg only)</span>
            </v-row>
            <v-row class="mt-3">
              <input type="file" accept="application/pdf,image/png,image/jpeg" multiple="multiple"
                @change="previewMultiImage" class="inputsize" ref="file" style="display: none" />
              <v-btn :style="{
                backgroundColor: '#254E58',
                color: 'white',
              }" class="widthbtnimagefile" @click="$refs.file.click()" elevation="7">
                <v-icon left dark color="white"> mdi-cloud-upload </v-icon>
                Upload file
              </v-btn>
            </v-row>
          </v-col>
          <v-col cols="12" md="8" align="start">
            <v-row class="pt-4 pb-4">
              <span style="font-size: 18px;">Files Name</span>
            </v-row>
            <div v-if="this.filenameattach.length > 0">
              <span style="font-size: 14px;" v-for="(item, index) in this.filenameattach" :key="index">
                <a @click="previewattachfile(index)">{{ item }}</a>

                <v-btn :style="{
                  backgroundColor: '#FFEBEE',
                  color: '#F44336',
                }" small icon @click="confirmdeleteattachfile(index)">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>

                <br />
              </span>
            </div>
          </v-col>

        </v-row>
        <!-- <v-row align="start" class="pb-10 pl-3">
          <v-col cols="12" md="4">
            <v-row class="pt-4">
              <span style="font-size: 18px;"> Upload File</span><span style="font-size: 14px; " class="red--text">(Support .pdf files only)</span>
            </v-row>
            <v-row>
                <input
                  type="file"
                  accept="application/pdf"
                  @change="previewMultiImage"
                  class="inputsize"
                  ref="filefile"
                  style="display: none"
                  multiple="multiple"
                />
                <v-btn
                  :style="{
                    backgroundColor: '#254E58',
                    color: 'white',
                  }"
                  class="widthbtnimagefile"
                  @click="$refs.filefile.click()"
                  elevation="7"
                >
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon>
                  Upload file
                </v-btn>
            </v-row>
          </v-col>
          <v-col cols="12" md="8"   align="start">
            <v-row class="pt-4 pb-4">
              <span style="font-size: 18px;">Files Name</span>
            </v-row>
              <span style="font-size: 14px;" v-for="(item, index) in this.filename" :key="index">
                <a 
                  @click="popuppreviewfile(index)"
                  :style="{
                          color: '#43a047'
                      }"
                > {{item}}</a>
                  <v-btn
                    :style="{
                        backgroundColor: '#FFEBEE',
                        color: '#F44336',
                      }"
                    small
                    icon
                    @click="popupdeletefile(index)"
                  >
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                  <br />
              </span>
          </v-col>
          
        </v-row> -->
        <!-- <v-row align="start" class="pb-10 pl-3">
          <v-col cols="12" md="4">
            <v-row class="pt-4">
              <span style="font-size: 18px;"> Upload Image</span><span style="font-size: 14px; " class="red--text">(Support Image only)</span>
            </v-row>
            <v-row>
              <input
                  type="file"
                  accept="image/png, image/jpeg, image/bmp"
                  @change="previewImage"
                  class="inputsize"
                  ref="fileimage"
                  style="display: none"
                  multiple="multiple"
                />
                <v-btn
                  :style="{
                    backgroundColor: '#254E58',
                    color: 'white',
                  }"
                  class="widthbtnimagefile"
                  @click="$refs.fileimage.click()"
                  elevation="7"
                >
                  <v-icon left dark color="white"> mdi-cloud-upload </v-icon
                  >Upload Image</v-btn
                >
            </v-row>
          </v-col>
          <v-col cols="12" md="8"   align="start">
            <v-row class="pt-4 pb-4">
              <span style="font-size: 18px;">Image Name</span>
            </v-row>
                <span style="font-size: 14px;" v-for="(item, index) in this.imagename" :key="index">
                  <a 
                  @click="popuppreviewimage(index)"
                  :style="{
                          color: '#43a047'
                      }"
                > {{ item }}</a>
                      
                <v-btn
                    :style="{
                        backgroundColor: '#FFEBEE',
                        color: '#F44336',
                      }"
                    small
                    icon
                    @click="popupdeleteimage(index)"
                  >
                    <v-icon small>mdi-close</v-icon>
                </v-btn>
                <br />
              </span>
          </v-col>
        </v-row> -->


        <v-row>
          <v-col>
            <v-text-field v-model="remark" fill-width outlined dense label="Remark"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col align="center" cols="12" md="4">
            <v-row v-if="dialogSignature" :style="{ visibility: showsig1 ? 'visible' : 'hidden' }">
              <VueSignaturePad class="signature" width="90%" height="200" ref="firstsignaturePad" :options="options" />
              <v-row :style="{
                visibility: showbuttonsavesig1 ? 'visible' : 'hidden',
              }">
                <v-col align="center">
                  <v-btn depressed class="ml-5" @click="clearsig1()">
                    Clear
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn class="mr-5 mb-5 primary" depressed @click="savesig1()">
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <v-btn class="mr-2 mb-5" @click="editsig1()">
              {{ defaultwordbuttonsig1 }}
              <v-icon right>mdi-border-color</v-icon>
            </v-btn>
            <br />
            <hr />
            <p class="text-center">Requester</p>
            <p class="text-center" v-if="lbl_date_request">
              Date {{ dateCurrent }}
            </p>
          </v-col>

          <v-col align="center" cols="12" md="4" class="mt-6">
            <v-row v-if="dialogSignature" :style="{ visibility: showsig2 ? 'visible' : 'hidden' }">
              <VueSignaturePad class="signature" width="90%" height="200" ref="secondsignaturePad" :options="options" />
              <v-row :style="{
                visibility: showbuttonsavesig2 ? 'visible' : 'hidden',
              }">
                <v-col align="center">
                  <v-btn depressed class="ml-5" @click="clearsig1()">
                    Clear
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn class="mr-5 mb-5 primary" depressed @click="savesig1()">
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <!-- <v-btn
              v-if="this.role !== 'EMPLOYEE'"
              class="mr-2"
              @click="editsig1()"
            >
              {{ defaultwordbuttonsig2 }}
              <v-icon right>mdi-border-color</v-icon>
            </v-btn> -->

            <br />
            <hr />
            <p class="text-center">Approver</p>
            <!-- <p class="text-center" >Date {{ dateCurrent }}</p> -->
          </v-col>
          <v-col align="center" cols="12" md="4" class="mt-6">
            <v-row v-if="dialogSignature" :style="{ visibility: showsig2 ? 'visible' : 'hidden' }">
              <VueSignaturePad class="signature" width="90%" height="200" ref="secondsignaturePad" :options="options" />
              <v-row :style="{
                visibility: showbuttonsavesig2 ? 'visible' : 'hidden',
              }">
                <v-col align="center">
                  <v-btn depressed class="ml-5" @click="clearsig2()">
                    Clear
                  </v-btn>
                </v-col>
                <v-col>
                  <v-btn class="mr-5 mb-5 primary" depressed @click="savesig2()">
                    Save
                  </v-btn>
                </v-col>
              </v-row>
            </v-row>
            <!-- <v-btn
              v-if="this.role !== 'EMPLOYEE'"
              class="mr-2"
              @click="editsig2()"
            >
              {{ defaultwordbuttonsig2 }}
              <v-icon right>mdi-border-color</v-icon>
            </v-btn> -->
            <br />

            <hr />
            <p class="text-center">Cashier</p>
            <!-- <p class="text-center">Date {{ dateCurrent }}</p> -->
          </v-col>
        </v-row>
        <br />
        <hr />
        <br />
        <div :style="{ display: showbtnadd ? 'show' : 'none' }">
          <v-row>
            <v-col align="center" cols="12" md="12">
              <v-btn class="mr-5 buttonblue" color="#689ADE" @click="saveData('Draft')" width="180">
                Save Draft
              </v-btn>
              <v-btn depressed width="180" class="mr-5 buttonblue" @click="saveData('Submit')">
                Submit Request
              </v-btn>
              <v-btn depressed outlined class="mr-5" width="180" @click="$router.back()">
                Cancel
              </v-btn>

              <!-- <v-btn depressed>
                Cancel Request
              </v-btn> -->
            </v-col>
          </v-row>

          <!-- <v-row>
            <v-col align="end" cols="12" md="12">
              <v-btn depressed class="buttonred">
                Delete form
              </v-btn>
            </v-col>
          </v-row> -->
        </div>
        <div :style="{ display: showbtnapprove ? 'show' : 'none' }">
          <v-row>
            <v-col align="center" cols="12" md="12">
              <v-btn depressed class="mr-5 buttonred" @click="saveAdvanceRequest()">
                Reject
              </v-btn>
              <v-btn depressed class="mr-5 buttonblue" @click="saveAdvanceRequest()">
                Approve
              </v-btn>

              <v-btn depressed>
                Return
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-card>

      <v-dialog v-model="dialogSendMail" max-width="500px">
        <v-card>
          <v-card-title class="text-h6">Information Saved</v-card-title>
          <v-card-subtitle>
            บันทึกข้อมูลและส่งอีเมล์ถึงผู้อนุมัติสำเร็จ
          </v-card-subtitle>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!-- <v-btn color="blue darken-1" text @click="closeDeleteForm"
              >Cancel</v-btn
            > -->
            <v-btn color="blue darken-1" text @click="closeDialogSendmail()">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogSaveDraft" max-width="30%">
        <v-card>
          <v-card-title primary-title class="justify-center">
            {{ this.messageSaveDraft }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeSaveDraft">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- <v-dialog v-model="dialogDeletefile" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDeletefile">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deleteItemConfirmfile">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <!-- <v-dialog v-model="dialogpreviewimage" max-width="700px">
        <v-card>
          <v-card-title class="text-h5">
            <v-row>
              <v-col cols="12" md="6">
                Preview Image
              </v-col>
              <v-col cols="12" md="6" class="d-flex justify-end">
                <v-btn icon @click="closepreviewimage">
                  <v-icon large>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-img disabled :src="previewimageshow" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
          </v-img>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closepreviewimage">Cancel</v-btn>

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <!-- <v-dialog v-model="dialogDeleteimage" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDeleteimage">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="removeimage">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <!-- <v-dialog v-model="dialogpreviewattachfile" max-width="700px">
        <v-card>
          <v-card-title class="text-h5">
            <v-btn icon @click="closepreviewattachfile">
              <v-icon large>mdi-close</v-icon>
            </v-btn>
            Preview PDF File</v-card-title
          >
          <div
            v-if="checkattachfileapreview"
            v-for="(item, index) in previewpopupattachfile2"
            :key="index"
          >
            <pdf
              :src="item"
              v-for="i in numPagespreviewattach"
              :key="i"
              :id="i"
              :page="i"
            >
              <template slot="loading">
                loading content here...
              </template>
            </pdf>
          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closepreviewattachfile"
              >Cancel</v-btn
            >

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
      <v-dialog v-model="dialogpreviewattachimage" max-width="700px">
        <v-card>
          <v-card-title class="text-h5">
            <v-row>
              <v-col cols="12" md="6">
                Preview Image
              </v-col>
              <v-col cols="12" md="6" class="d-flex justify-end">
                <v-btn icon @click="closepreviewattachimage">
                  <v-icon large>mdi-close</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-img disabled :src="previewattachimage" class="grey lighten-2 mt-3 mb-5" aspect-ratio="1" contain>
          </v-img>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closepreviewattachimage">Cancel</v-btn>

            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogconfirmdeleteattachfile" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this file?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closedialogconfirmdeleteattachfile">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="deletedialogconfirmdeleteattachfile">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <SuccessDialog :status="dialogAdd" :text_color="text_color" :title="title" :message="message" />

      <SuccessDialogPush :status="dialogAdd" :text_color="text_color" :title="title" :message="message" :link="link" />
    </v-container>
  </v-card-title>
</template>

<script>
import api from "@/services/api";
import { server } from "@/services/constants";
import StockCard from "@/components/cards/StockCard";
import SuccessDialog from "@/components/cards/SuccessDialog";
import SuccessDialogPush from "@/components/cards/SuccessDialogPush";
import unity from "@/unity/unity";
import pdfvuer from "pdfvuer";
import {
  tolocalestringnumber,
  stringcommatonumber,
} from "../computing/tolocalestringnumber";
export default {
  name: "NewAdvance",
  data() {
    return {
      //file
      // indeximageDelete: 0,
      // preview_list2: [],
      // getpreview_list: [],
      // image: [],
      // previewimage: null,
      // previewimageedit: null,
      // image_list: [],
      // preview_list: [],
      // dialogpreviewimage: false,
      // checkfileapreview: false,
      // previewpopupfile: [],
      // previewpopupfile2: [],
      // dialogpreviewfile: false,
      dialogDeletefile: false,
      // dialogDeleteimage: false,
      // filename: [],
      // imagename: [],
      // load_bg: false,
      // checkfileadd: false,
      // checkimageadd: false,
      previewpopupfile2: [],
      filenameattach: [],
      previewpopupattachfile2: [],
      previewpopupattachfile: [],
      checkattachfileapreview: false,
      dialogpreviewattachfile: false,
      dialogpreviewattachimage: false,
      dialogconfirmdeleteattachfile: false,
      numPagespreviewattach: 0,
      previewattachimage: "",
      indexdeleteattachfile: -1,
      getpreview_listattach: [],
      preview_listattach: [],
      image_listattach: [],
      //--
      showbtnadd: true,
      showbtnapprove: false,
      advance_code: [],
      advance_code_list: [],
      advance_code_id: 0,
      dialogAdd: false,
      dialogSendMail: false,
      text_color: "text-h5 green--text text-center",
      title: "green",
      message: "green",
      link: "",
      customer: [],
      customer_list: [],
      customer_id: 0,
      emp_draw: 0,
      emp_draw_jobtitle: 0,
      options: {
        penColor: "#000000",
        backgroundColor: "rgb(255,255,255)",
      },
      initial_data2: "",
      initial_data: "",
      pickbank: false,
      pickcheque: false,
      checkcheque: false,
      checkchequefilled: false,
      showsig1: false,
      showsig2: false,
      showbuttonsavesig1: false,
      showbuttonsavesig2: false,
      defaultwordbuttonsig1: "Signature",
      defaultwordbuttonsig2: "Signature",
      totalleftoveramount: 0.0,
      sumwithdrawamount: 0.0,
      sunamountcleared: 0.0,
      showallamount: "",
      desserts: [
        {
          no: "1",
          detail: "",
          withdrawamount: 0,
        },
      ],
      selectbankname: "",
      bankname: [
        "ธนาคารกรุงเทพ",
        "ธนาคารกสิกรไทย",
        "ธนาคารกรุงไทย",
        "ธนาคารทหารไทยธนชาต",
        "ธนาคารไทยพาณิชย์",
        "ธนาคารกรุงศรีอยุธยา",
        "ธนาคารเกียรตินาคินภัทร",
        "ธนาคารซีไอเอ็มบีไทย",
        "ธนาคารทิสโก้",
        "ธนาคารยูโอบี",
        "ธนาคารไทยเครดิตเพื่อรายย่อย",
        "ธนาคารแลนด์ แอนด์ เฮ้าส์",
        "ธนาคารไอซีบีซี (ไทย)",
        "ธนาคารพัฒนาวิสาหกิจขนาดกลางและขนาดย่อมแห่งประเทศไทย",
        "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร",
        "ธนาคารเพื่อการส่งออกและนำเข้าแห่งประเทศไทย",
        "ธนาคารออมสิน",
        "ธนาคารอาคารสงเคราะห์",
        "ธนาคารอิสลามแห่งประเทศไทย",
      ],
      radioType: ["cash", "cheque"],
      radioGroup: "",
      setusername: localStorage.getItem(server.USERNAME),
      role: localStorage.getItem(server.ROLE),
      department: "",
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateCurrent: unity.formatDate(
        new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
          .toISOString()
          .substr(0, 10)
      ),
      menu: false,
      modal: false,
      menu2: false,
      search: "",
      selectedProductId: "",
      confirmDeleteDlg: false,
      mDataArray: [],
      previewimageshow: null,
      // mDataArray: [{ id: "1", detail: "gg", amout: "1000" }],
      fullPage: true,
      dialog: false,
      dialogDelete: false,
      headers: [
        {
          text: "Particular",
          value: "description",
          class: "my-header-style",
        },
        { text: "Amount", value: "amount", class: "my-header2-style " },
        {
          text: "Action",
          value: "actions",
          class: "my-header3-style  text-center",
        },
      ],
      desserts: [],
      jobtitle_list: [],
      editedIndex: -1,
      editedItem: {
        code: "",
        description: "",
        amount: 0,
      },
      defaultItem: {
        code: "",
        description: "",
        amount: 0,
      },
      advance_d: {
        advance_hid: "",
        advance_title: "",
        description: "",
        amount: 0,
      },
      advance_h: {
        advance_id: "",
        customer_id: 0,
        employee_id: 0,
        department_id: 0,
        company_id: localStorage.getItem(server.COMPANYID),
        advance_date: null,
        sum_amount: 0,
        clear_date: null,
        payment_type: null,
        bank_name: null,
        bank_number: null,
        cheque_number: null,
        status: null,
        remark: null,
        create_by: null,
        create_date: null,
      },
      lbl_date_request: false,
      dialogSignature: false,
      dialogSaveDraft: false,
      messageSaveDraft: "",
      paymentType: "",
      bankName: "",
      bankNumber: "",
      chequeNumber: "",
      remark: "",
      emp_list: [],
      sendMail: {
        name: "",
        email: "",
        advance_id: "",
        link: "",
      },
      account: {
        signature: "",
      },
      advance_log: {
        module: "AD",
        module_id: 0,
        approve_id: 0,
        approve_status: 0,
        approve_date: null,
      },
    };
  },
  components: {
    StockCard,
    SuccessDialog,
    SuccessDialogPush,
  },
  computed: {
    version() {
      return this.initial_data;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
    computedExpectedClearDateFormatted() {
      return unity.formatDate(this.date);
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogDeletefile(val) {
      val || this.closeDeletefile();
    },
  },

  async mounted() {


    this.$forceUpdate();

    this.initialize();
    try {
      await this.loadEmp();
    } catch (e) { console.error("ตาย loadEmp:", e); }

    try {
      await this.loadJobtitle();
    } catch (e) { console.error("ตาย loadJobtitle:", e); }

    try {
      await this.loadCustomer();
    } catch (e) { console.error("ตาย loadCustomer:", e); }

    const res_acc = await api.getAccountDetail(
      localStorage.getItem(server.USER_ID)
    );

    this.setusername =
      res_acc.data[0].prename_e_n +
      " " +
      res_acc.data[0].firstname_e_n +
      " " +
      res_acc.data[0].lastname_e_n;

    // alert(res_acc.data[0].department_i_d);
    const res_department = await api.billing_expense_getDepartmentByID(
      res_acc.data[0].department_i_d
    );

    this.department = res_department.data[0].name;

    // console.log(
    //   "res_department : ",
    //   JSON.stringify(res_department.data[0].name)
    // );

    this.department_view = res_department.data[0].name;
    // console.log("res_acc : ", JSON.stringify(res_acc.data[0].signature));

    this.user_sign = res_acc.data[0].signature;

    this.showsig1 = true;
    this.dialogSignature = true;
    await this.$nextTick();
    this.showdefaultsignature();
    // this.savesig1();


    this.$hideLoader();
    const userId = localStorage.getItem(server.USER_ID);
    if (userId && api.isLoggedIn()) {
      // this.$router.push("/");
    } else {
      this.$store.state.isLogged = false;
      this.$router.push("/login");
    }

  },
  methods: {
    //set auto complte

    async loadEmp() {
      const result = await api.getAccountslist_by_ComID(
        localStorage.getItem(server.COMPANYID)
      );

      this.emp_list = result.data;
      // console.log("this.emp_list")
      // console.log(this.emp_list)
    },
    async loadJobtitle() {
      const result = await api.getAllJobtitleByCompany(
        localStorage.getItem(server.COMPANYID)
      );

      this.jobtitle_list = result.data;
    },

    async loadCustomer() {
      // console.log("loadCustomer");
      const result = await api.getAllCustomerListactiveCompany({
        params: {
          company_id: localStorage.getItem(server.COMPANYID),
        },
      });

      this.customer_list = result.data;

    },

    //end set auto complte

    //---------------function file------------//

    previewMultiImage: function (event) {
      this.filenameattach = [];
      var input = event.target;
      var count = input.files.length;
      var index = 0;
      if (input.files) {
        while (count--) {
          var reader = new FileReader();
          reader.onload = (e) => {
            // this.preview_list.push(e.target.result);
            this.getpreview_listattach.push(e.target.result);
            this.preview_listattach.push(e.target.result);
          };
          if (
            input.files[index].type === "application/pdf" ||
            input.files[index].type.split("/")[0] === "image"
          ) {
            this.image_listattach.push(input.files[index]);
            reader.readAsDataURL(input.files[index]);
          }
          index++;
        }
      }
      // console.log(this.image_list);
      this.image_listattach.forEach((x) => {
        this.filenameattach.push(x.name);
      });
      // console.log("this.filenameattach")
      // console.log(this.image_listattach)
      // console.log(this.filenameattach)
    },
    reset: function () {
      this.image = null;
      this.preview = null;
      this.image_list = [];
      this.preview_list = [];
    },
    async previewattachfile(index) {
      if (this.filenameattach[index].split(/[\s.]+/).pop() == "pdf") {
        await this.popuppreviewfile(index)
        // this.previewpopupattachfile2 = [];
        // await this.getPforpreviewattach(this.getpreview_listattach[index]);
        // this.previewpopupattachfile2 = this.previewpopupattachfile;
        // // console.log(this.previewpopupattachfile2);
        // this.checkattachfileapreview = true;
        // this.dialogpreviewattachfile = true;
      } else {
        this.previewattachimage = this.getpreview_listattach[index];
        this.dialogpreviewattachimage = true;
      }
    },
    async popuppreviewfile(fileindex) {
      let pdf_newTab = window.open("");
      pdf_newTab.document.write(
        "<html><head><title>pdf file</title></head><body><iframe title='MY title'  width='100%' height='100%' src='" +
        this.getpreview_listattach[fileindex] +
        "'></iframe></body></html>"
      );
    },
    // async getPforpreviewattach(datafile) {
    //   this.previewpopupattachfile = [];
    //   let getfile = "";
    //   getfile = datafile;
    //   this.previewpopupattachfile.push(pdfvuer.createLoadingTask(`${getfile}`));
    //   this.previewpopupattachfile.forEach((item, index) => {
    //     item.then((pdf) => {
    //       this.numPagespreviewattach = pdf.numPages;
    //     });
    //   });
    //   // console.log(this.previewpopupattachfile);
    // },
    // async closepreviewattachfile() {
    //   this.dialogpreviewattachfile = false;
    // },
    async closepreviewattachimage() {
      this.dialogpreviewattachimage = false;
    },
    async deletedialogconfirmdeleteattachfile() {
      this.filenameattach.splice(this.indexdeleteattachfile, 1);
      this.preview_listattach.splice(this.indexdeleteattachfile, 1);
      this.image_listattach.splice(this.indexdeleteattachfile, 1);
      this.getpreview_listattach.splice(this.indexdeleteattachfile, 1);
      this.dialogconfirmdeleteattachfile = false;
    },
    async confirmdeleteattachfile(index) {
      this.indexdeleteattachfile = index;
      this.dialogconfirmdeleteattachfile = true;
    },
    async closedialogconfirmdeleteattachfile() {
      this.indexdeleteattachfile = -1;
      this.dialogconfirmdeleteattachfile = false;
    },
    //--------------------end funcfile--------------------//

    closeDialogSendmail() {
      this.dialogSendMail = false;
      this.$router.push("/advance-list");
    },
    onSelectAdvanceCodeChange(acvance_code) {
      // var tmp = null;
      // tmp = this.customer.filter((c) => c.name.includes(search_customer));

      // this.customer_id = tmp[0].id;
      // console.log("acvance_code : " + acvance_code);
      var tmp = acvance_code.split(" ");
      this.editedItem.code = tmp[0];
      this.editedItem.description = tmp[1];
    },
    setupAlertDialog(status, title, message, text_color) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
    },
    setupAlertDialogPush(status, title, message, text_color, link) {
      this.title = title;
      this.message = message;
      this.dialogAdd = status;
      this.text_color = text_color;
      this.link = link;
    },
    async saveData(mode) {
      if (mode == "Submit") {
        const resCheckDoc = await api.checkDocRunning("PettyCash", localStorage.getItem(server.COMPANYID))
        if (resCheckDoc.status == 200) {
          if (!resCheckDoc.data[0].resCheckDoc) {
            // console.log(resCheckDoc.data)
            this.$store.state.global_dialog = true;
            this.setupAlertDialog(
              true,
              "Information Saved",
              "Please kindly check the value of document running.",
              "text-h5 red--text text-center"
            );
            return;
          }
        } else {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Information Saved",
            "ไม่สามารถบันทึกได้",
            "text-h5 red--text text-center"
          );
          return;
        }
      }
      if (this.emp_draw == 0) {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณาเลือกผู้รับเงิน",
          "text-h5 red--text text-center"
        );

        return;
      }

      if (this.paymentType == "") {
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Check your information again",
          "กรุณาเลือกวิธีการชำระเงิน",
          "text-h5 red--text text-center"
        );

        return;
      } else if (this.paymentType == "transfer") {
        if (this.selectbankname == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your information again",
            "กรุณาเลือกธนาคาร",
            "text-h5 red--text text-center"
          );

          return;
        }
        if (this.bankNumber == "") {
          this.$store.state.global_dialog = true;
          this.setupAlertDialog(
            true,
            "Check your information again",
            "กรุณากรอกเลขบัญชี",
            "text-h5 red--text text-center"
          );

          return;
        }
      }

      const resultDataModlue = await api.getApproverManagementModule(`PettyCash`);
      console.log("status:", resultDataModlue.status);
      console.log("data:", JSON.stringify(resultDataModlue.data));

      let dataAdd = {
        pettycas_id: "",
        requester: Number(localStorage.getItem(server.USER_ID)),
        employee_id: this.emp_draw,
        company_id: Number(localStorage.getItem(server.COMPANYID)),
        department_id: Number(localStorage.getItem(server.DEPARTMENT_ID)),
        job_id: this.emp_draw_jobtitle,
        customer_id: this.customer_id,
        document_date: unity.parseDate(this.dateCurrent),
        payment_type: this.radioGroup,
        bank_name: this.selectbankname,
        bank_number: this.bankNumber,
        approver_id: Number(localStorage.getItem(server.APPROVE_LEVEL1)),
        cashier_id: resultDataModlue.data[0].approver_id,
        status: 0,
        remark: this.remark,
        remark_reject: "",
        create_by: Number(localStorage.getItem(server.USER_ID)),
      }
      if (mode == "Submit") {
        dataAdd.status = 1;
      }

      this.$showLoader();
      const req_app = await api.getAccountid(this.emp_draw);
      dataAdd.approver_id = req_app.data[0].approver_level1;
      const res_data_h = await api.billing_expense_createPC(dataAdd);
      // console.log(res_data_h.status)
      if (Number(res_data_h.status) == 200 || Number(res_data_h.status) == 201) {

        if (this.image_listattach.length > 0) {
          for (const [index, item] of this.image_listattach.entries()) {
            let formData = new FormData();
            formData.append("module_name", "PettyCash");
            formData.append("module_id", res_data_h.data.id);
            formData.append("company_id", Number(localStorage.getItem(server.COMPANYID)));
            formData.append("create_by", Number(localStorage.getItem(server.USER_ID)));
            formData.append(`file`, item);

            const res_file = await api.billing_expense_createFA(formData)
          }
        }
        if (this.desserts.length > 0) {
          for (const [index, item] of this.desserts.entries()) {

            let dataD_add = {
              pettycash_h_id: res_data_h.data.id,
              title: item.description,
              amount: Number(item.amount),
              create_by: Number(localStorage.getItem(server.USER_ID))
            }

            await api.billing_expense_createPCD(dataD_add)
            if (index == (this.desserts.length - 1)) {
              this.$hideLoader();
              this.$store.state.global_push_dialog = true;
              this.setupAlertDialogPush(
                true,
                "Information Saved",
                "Information successfully saved",
                "text-h5 green--text text-center",
                "/petty-cash-voucher"
              );
            }
          }
        } else {
          this.$hideLoader();
          this.$store.state.global_push_dialog = true;
          this.setupAlertDialogPush(
            true,
            "Information Saved",
            "Information successfully saved",
            "text-h5 green--text text-center",
            "/petty-cash-voucher"
          );
        }



      } else if (Number(res_data_h.status) == 404) {
        this.$hideLoader();
        this.$store.state.global_dialog = true;
        this.setupAlertDialog(
          true,
          "Information Saved",
          "ไม่สามารถบันทึกได้",
          "text-h5 red--text text-center"
        );
        return;
      } else {
        return;
      }
    },



    changeFocusText(t) {
      if (t === 1) {
        this.$refs["txtDescription"].focus();
      }
      if (t === 2) {
        alert("กรุณากรอกรายละเอียด");
        this.$refs["txtDescription"].focus();
      } else if (t === 3) {
        alert("กรุณากรอกราคา");
        this.$refs["txtAmount"].focus();
      }
    },
    initialize() {

      this.sumwithdrawamount = 0;

      this.desserts.forEach((item) => {
        this.sumwithdrawamount += item.amount;
      });

      this.sumwithdrawamount = tolocalestringnumber(this.sumwithdrawamount);
    },

    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.desserts.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeSaveDraft() {
      this.dialogSaveDraft = false;
    },

    closeDelete() {
      this.sumwithdrawamount = 0;

      this.desserts.forEach((item) => {
        this.sumwithdrawamount += parseInt(item.amount, 10);
      });

      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      if (this.editedItem.description == "") {
        alert("กรุณากรอกรายละเอียดรายการ");
        this.$refs["txtDescription"].focus();
        return;
      }

      if (this.editedItem.amount == "0" || this.editedItem.amount == 0) {
        alert("กรุณากรอกจำนวนเงิน");
        this.$refs["txtAmount"].focus();
        return;
      }

      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }

      this.sumwithdrawamount = 0;

      this.desserts.forEach((item) => {
        this.sumwithdrawamount += parseInt(item.amount, 10);
      });
      this.sumwithdrawamount = tolocalestringnumber(this.sumwithdrawamount);

      // console.log("save : " + JSON.stringify(this.desserts));
      this.changeFocusText(1);
      this.close();
    },

    submit() {
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#F1F4F7",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide();
      }, 2000);
    },
    editsig1() {
      this.dialogSignature = true;
      this.lbl_date_request = false;
      this.showsig1 = true;
      this.showbuttonsavesig1 = true;
      this.$refs.firstsignaturePad.openSignaturePad();
    },
    editsig2() {
      this.showsig2 = true;
      this.showbuttonsavesig2 = true;
      this.$refs.secondsignaturePad.openSignaturePad();
    },
    clearsig1() {
      this.lbl_date_request = false;
      this.$refs.firstsignaturePad.clearSignature();
    },
    clearsig2() {
      this.$refs.secondsignaturePad.clearSignature();
    },
    async savesig1() {
      this.lbl_date_request = true;
      this.defaultwordbuttonsig1 = "Edit";
      const { isEmpty, data } = this.$refs.firstsignaturePad.saveSignature();
      this.showbuttonsavesig1 = false;
      this.$refs.firstsignaturePad.lockSignaturePad();
      // console.log("user_sign : " + data);
      // console.log("user_sign1 : " + this.user_sign);
      this.user_sign = data;
      this.account.signature = data;
      let loader = this.$loading.show({
        // Optional parameters
        color: "green",
        loader: "dots",
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        width: 120,
        height: 120,
        backgroundColor: "#ffffff",
        opacity: 0.5,
        zIndex: 999,
        onCancel: this.onCancel,
      });
      await api.updateAccount(
        localStorage.getItem(server.USER_ID),
        this.account
      );
      loader.hide();
    },
    savesig2() {
      this.defaultwordbuttonsig2 = "Edit";
      const { isEmpty, data } = this.$refs.secondsignaturePad.saveSignature();
      this.showbuttonsavesig2 = false;
      this.$refs.secondsignaturePad.lockSignaturePad();
    },
    changeradio() {
      // console.log(this.radioGroup);
      if (this.radioGroup === "bank") {
        this.paymentType = "transfer";
        this.pickbank = true;
      } else {
        this.paymentType = "cash";
        this.pickbank = false;
        this.selectbankname = "";
        this.bankNumber = "";
      }
    },

    showdefaultsignature() {
      this.$nextTick(() => {
        // this.$refs.signaturePaddefault.fromDataURL(this.initial_data);
        // this.$refs.signaturePaddefault.lockSignaturePad();
        this.$refs.firstsignaturePad.fromDataURL(this.user_sign);
        // this.$refs.firstsignaturePad.lockSignaturePad();
        this.$refs.secondsignaturePad.fromDataURL(this.initial_data2);
        // this.$refs.secondsignaturePad.lockSignaturePad();
      });
    },
  },
  async beforeCreate() {
    // console.log("beforeCreate");
    this.$store.state.navMenu = true;
    // this.showdefaultsignature();
  },
  async created() {
    // this.showdefaultsignature();
  },
};
</script>

<style scoped>
.text-left {
  color: aliceblue;
}

.v-btn:not(.v-btn--round).v-size--default.buttonblue {
  background-color: #1d2442;
  color: white;
}

.v-btn:not(.v-btn--round).v-size--default.buttonred {
  background-color: #9e3b1b;
  color: white;
}

.v-autocomplete.v-input>.v-input__control>.v-input__slot {
  min-height: 10px;
}

.widthsizeformadvance {
  width: 60%;
}

.bd-block-tb {
  border-block: 1px solid gray;
  writing-mode: horizontal-tb;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.bd-block-lr {
  border-block: 1px solid gray;
  writing-mode: vertical-lr;
  margin-left: 0%;
  margin-right: 0%;
  height: 45px;
}

.widthsize80formadvance {
  width: 80%;
}

.heightsize55formadvance {
  height: 55px;
}

.heightsize80performadvance {
  height: 60%;
}

.heightsize70formadvance {
  height: 70px;
}

.widthsize8055formadvance {
  width: 80px;
  height: 55px;
}

.advance-text-height {
  height: 70px;
}

.some-other-style {
  background: blue;
}

.my-header-style {
  color: #ffffff !important;
  background: #515151;
}

.data-table-button {
  color: #9e3b1b;
}

.my-header2-style {
  color: #ffffff !important;
  background: #515151;
  width: 120px;
}

.my-header3-style {
  color: #ffffff !important;
  background: #515151;
  width: 80px;
}

.my-header4-style {
  color: #ffffff !important;
  background: #515151;
  width: 150px;
}
</style>
